export default __webpack_public_path__ + "static/jon-1f74b6eee754c936c6a4df42664d140a.jpg";